module.exports = "/dist/img/noshi_soto.851a654a.png";